import React from 'react'
import styled from 'styled-components'
import order_detailStyles from './order_detail.styles'

const apAtomName = {ap_atom_name: 'apOrderDetailAtom'}

const StyledWrapper = styled(props => <div {...props} />)`
  ${order_detailStyles}
`

const OrderDetailAtom: React.FC = function ({children}) {
  return <StyledWrapper {...apAtomName}>{children}</StyledWrapper>
}

export default OrderDetailAtom
